import { render, staticRenderFns } from "./comp-copybtn.vue?vue&type=template&id=a4f8861c&"
import script from "./comp-copybtn.vue?vue&type=script&lang=js&"
export * from "./comp-copybtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports